import { APIPickTour, GetOrdersResponse, GetOrdersResponseItem } from './types';
import { SetOrdersPayload } from '../actions/orders.types';
import { Order, OrderType } from '../../types';

/**
 * Maps a single order response item to the Order domain model
 */
const mapOrderItem = (item: GetOrdersResponseItem): Order => ({
  id: item.orderID,
  type: item.orderType,
  deliveryMethod: item.deliveryMethod,
  destination: item.destination,
  quantity: item.quantity,
  finalizationErrorCode: item.finalizationErrorCode,
  finalizationErrorMessage: item.finalizationErrorMessage,
  isRetryEnabled: item.isRetryEnabled,
  isUpcScanRequired: item.isUpcScanRequired,
  date: item.date,
  sequenceNumber: item.orderSequenceNumber,
  recallDescription: item.recallDescription,
  recallType: item.recallType,
  supplierID: item.supplierID,
  dispatchTime: item.dispatchTime,
});

/**
 * Checks if an order type group has any content
 */
const hasOrderGroupContent = (group: {
  orders: Order[];
  errorPickTours: APIPickTour[];
  pickTours: APIPickTour[];
}): boolean => group.orders.length > 0 || group.errorPickTours.length > 0 || group.pickTours.length > 0;

/**
 * Maps the API response to the Redux store payload format
 */
export const mapGetOrdersResponseToSetOrdersPayload = (response: GetOrdersResponse): SetOrdersPayload => {
  const transformedOrdersByType: SetOrdersPayload['ordersByType'] = {};

  Object.keys(response.ordersByType || {}).forEach((orderTypeKey: string) => {
    const orderType = orderTypeKey as OrderType;
    const group = response.ordersByType[orderType];

    if (!group) {
      return;
    }

    const orderTypeGroup = {
      orders: group.orders.map(mapOrderItem),
      errorPickTours: group.errorPickTours || [],
      pickTours: group.pickTours || [],
      sortOrder: group.sortOrder,
    };

    if (hasOrderGroupContent(orderTypeGroup)) {
      transformedOrdersByType[orderType] = orderTypeGroup;
    }
  });

  return {
    ordersByType: transformedOrdersByType,
  };
};
